import React, { useState } from 'react'
import './ApplicationForm.css'
import CommonHeadingAfterLine from '../../Common-Component/CommonHeadingAfterLine/CommonHeadingAfterLine'
import { Form } from 'react-bootstrap'
import classNames from "classnames";
import { useForm, Controller } from "react-hook-form";
import Black_Btn from '../../Common-Component/Common_Btn/Black_Btn/Black_Btn';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileArrowUp } from '@fortawesome/free-solid-svg-icons';
import Successfull_Lottie from '../../Animation/Successfull_Lottie/Successfull_Lottie';
import { careerForm } from '../../../features/career_form/careerformSlice';
import { useDispatch } from "react-redux";

const ApplicationForm = ({careers}) => {


const [showLottie, setShowLottie] = useState(false);

    const [applied, setApplied] = useState(false)

    const {
        control,
        register,
        handleSubmit,
        getValues,
        setError,
        clearErrors,
        formState: { errors },
        reset,
        trigger,
    } = useForm();
    const dispatch = useDispatch();
    const onSubmit = async (data) => {
        const formData = new FormData();
        formData.append("career_id", careers.id); 
        formData.append("f_name", data.first_name);
        formData.append("l_name", data.last_name);
        formData.append("email", data.email);
        formData.append("mobile", data.contact_no);
        formData.append("cover_letter", data.cover_letter);
        formData.append("cv", data.resume?.[0]); // File input
      
        dispatch(careerForm(formData));

    }

    
    return (
        <section className='ApplicationForm'>
            <div className='heading_div'>
                <CommonHeadingAfterLine headingText="Apply for this Position" />
            </div>

            <div className='form_div'>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <div className='row'>
                        <div className='col-md-6 mb-sm-3 mb-2'>
                            <div className='form-group'>
                                <Form.Label>First Name*</Form.Label>
                                <Form.Control
                                    className={classNames("", {
                                        "is-invalid": errors?.first_name,
                                    })}
                                    type="text" name="first_name" placeholder="Enter First Name"

                                    {...register("first_name", {
                                        required: "Name is required",
                                        pattern: {
                                            value: /^[A-Za-z ]*$/,
                                            message: "Name must contain only letters",
                                        },
                                    })}
                                    onKeyDown={(event) => {
                                        if (!/[A-Z-a-z ]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }}
                                />
                                {errors?.first_name && (
                                    <span className="text-danger">
                                        {errors?.first_name?.message}
                                    </span>
                                )}

                            </div>
                        </div>
                        <div className='col-md-6 mb-sm-3 mb-2'>
                            <div className='form-group'>
                                <Form.Label>Last Name*</Form.Label>
                                <Form.Control
                                    className={classNames("", {
                                        "is-invalid": errors?.last_name,
                                    })}
                                    type="text" name="last_name" placeholder="Enter Last Name"
                                    {...register("last_name", {
                                        required: "Last Name is required",
                                        pattern: {
                                            value: /^[A-Za-z ]*$/,
                                            message: "Last Name must contain only letters",
                                        },
                                    })}
                                    onKeyDown={(event) => {
                                        if (!/[A-Z-a-z ]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }}
                                />
                                {errors?.last_name && (
                                    <span className="text-danger">
                                        {errors?.last_name?.message}
                                    </span>
                                )}
                            </div>
                        </div>
                        <div className='col-md-6 mb-sm-3 mb-2'>
                            <div className='form-group'>
                                <Form.Label>Email*</Form.Label>
                                <Form.Control
                                    className={classNames("", {
                                        "is-invalid": errors?.email,
                                    })}
                                    type="email" name="email" placeholder="Enter Email"
                                    {...register("email", {
                                        required: "E-mail is required",
                                        pattern: {
                                            value: /^([A-Za-z0-9_\-\.])+\@(?!(?:[A-Za-z0-9_\-\.]+\.)?([A-Za-z]{2,4})\.\2)([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,
                                            message: "Invalid E-Mail Address",
                                        },
                                    })}
                                />

                                {errors?.email && (
                                    <span className="text-danger">
                                        {errors?.email?.message}
                                    </span>
                                )}
                            </div>
                        </div>
                        <div className='col-md-6 mb-sm-3 mb-2'>
                            <div className='form-group'>
                                <Form.Label>Contact Number</Form.Label>
                                <Form.Control
                                    className={classNames("", {
                                        "is-invalid": errors?.contact_no,
                                    })}
                                    type="text" name="contact_no" placeholder="Enter contact_no"
                                    {...register("contact_no", {
                                        required: "contact_no is required",
                                        pattern: {
                                            // value: /^[A-Za-z ]*$/,
                                            message: "",
                                        },
                                    })}
                                />
                                {errors?.contact_no && (
                                    <span className="text-danger">
                                        {errors?.contact_no?.message}
                                    </span>
                                )}
                            </div>
                        </div>
                        <div className='col-md-12 mb-sm-3 mb-2'>
                            <div className="form-group">
                                <Form.Label>Cover Letter *</Form.Label>
                                <Form.Control
                                    as={"textarea"}
                                    className={classNames("", {
                                        "is-invalid": errors?.cover_letter,
                                    })}
                                    type="text"
                                    name="cover_letter"
                                    {...register("cover_letter", {
                                        required: "Cover Letter is required",
                                        pattern: {
                                            value: /^[A-Za-z ]*$/,
                                            message: "Cover Letter must contain only letters",
                                        },
                                    })}
                                    placeholder="Type From here..."
                                    onKeyDown={(event) => {
                                        if (!/[A-Z-a-z ]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }}
                                />
                                {errors?.cover_letter && (
                                    <span className="text-danger">
                                        {errors?.cover_letter?.message}
                                    </span>
                                )}
                            </div>
                        </div>
                        <div className='col-md-12 mb-sm-3 mb-2'>
                            <div className="form-group">
                                <Form.Label>Upload your CV*</Form.Label>
                                <div className="custom_form_group">
                                    <div className="first_div">


                                        <div className="file_upload_left" onClick={() => document.getElementById("cv-upload").click()}>
                                            <div className='text_icon_holder'>
                                                <span className='choose_text'>Choose File</span>
                                                <FontAwesomeIcon className="upload_icon" icon={faFileArrowUp} />
                                            </div>
                                            <span className="file_name">No choosen file</span>
                                        </div>



                                        <Form.Control
                                            type="file"
                                            id="cv-upload"
                                            className="file-input"
                                            {...register("resume", { required: "Please Upload a cv" })}
                                            accept=".doc,.docx,.rtf,.pdf"
                                            // onChange={(e) => {
                                            //     const fileName = e.target.files[0] ? e.target.files[0].name : "No chosen file";
                                            //     document.querySelector(".file_name").textContent = fileName;
                                                
                                            // }}
                                        />

                                        

                                        {errors?.cv && (
                                            <span className="invalid-feedback d-block">{errors.cv.message}</span>
                                        )}
                                    </div>


                                    <div className="second_div">
                                        <span className="smalltext">Allowed Type(s): .pdf, .doc, .docx</span>
                                    </div>
                                </div>

                                {errors.cv && (
                                    <span className="text-danger">
                                        {errors.cv?.message}
                                    </span>
                                )}
                            </div>
                        </div>

                        <div className='col-md-12'>
                            <Form.Check
                                type="checkbox"
                                id="agree"
                                label="By using this form you agree with the storage and handling of your data by this website"
                                {...register("agree", { required: "You must agree before submitting" })}
                                className={classNames("", { "is-invalid": errors?.agree })}
                            />
                        </div>

                    </div>

                    {/* <div className='submit_btn_holder' onClick={() => { setApplied(true) }} > */}
                    <div className='submit_btn_holder' >

                    <Black_Btn btnText={"Submit"} type={"submit"} />
                        {/* {!applied ? (
                            <Black_Btn btnText={"Submit"} type={"submit"} />
                        ) :
                            (
                                <div className="success_main_div">
                                    <div className="success_loottie_holder">
                                        <Successfull_Lottie />
                                    </div>

                                    <div className="success_content_holder">
                                        <div className="text_holder">
                                            <p className="heading">Applied for job position Successfully!!</p>
                                        </div>
                                    </div>
                                </div>
                            )} */}

                    </div>
                </Form >
            </div>

        </section>
    )
}

export default ApplicationForm